var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWaitTimes = function SvgWaitTimes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.253v1.553a8.283 8.283 0 1 0 13 2.675l.001-2.311A9.459 9.459 0 0 1 20.5 11a9.5 9.5 0 1 1-15-7.747zM12.95 7.5a2.603 2.603 0 0 1 2.598 2.491h.002l.037.938.013.148-.002.118.002.053h-.003l-.002.075a4.595 4.595 0 0 1-6.99 3.7l-.201-.131-.205-.15.001.558a.6.6 0 0 1-.41.57l-.093.022-.097.008a.6.6 0 0 1-.592-.502L7 15.3v-2a.6.6 0 0 1 .506-.592L7.6 12.7h2a.6.6 0 0 1 .097 1.192L9.6 13.9h-.516l.115.078c.85.536 1.897.667 2.854.357l.204-.073.2-.087a3.393 3.393 0 0 0 1.943-3.06l-.043-.924-.007-.09c0-.728-.556-1.326-1.265-1.394L12.95 8.7h-2a1.4 1.4 0 0 0-1.393 1.265l-.007.135a.6.6 0 1 1-1.2 0 2.603 2.603 0 0 1 2.436-2.595l.164-.005h2zm-1-6a2.6 2.6 0 1 1 0 5.2 2.6 2.6 0 0 1 0-5.2zm0 1.2a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgWaitTimes;